module.exports = __webpack_public_path__ + "static/media/zolty_normal.c460018d.png";